<template>
  <div class="form-check">
    <input
    :id="id"
      class="form-check-input"
      type="radio"
      :name="name"
      :value="$attrs.value"
      :checked="modelValue == $attrs.value"
      @input="$emit('update:modelValue', $event.target.value)"
      :disabled="disabled"
    />
    <label class="custom-control-label" :for="id">
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  name: "MaterialRadio",
  props: {
    name: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Number
    },
    id: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

